(function () {
  const WORKER_URL = "https://shopify-color-swatches.sales-af1.workers.dev";

  // ── Per-product-id color map cache ────────────────────────────────────────
  // Key: productId string (or "" for the global map)
  const cache = {};
  const TTL_MS = 30 * 1000;

  async function fetchMapForProduct(productId) {
    const ts = Date.now();
    const url = productId
      ? `${WORKER_URL}/colors-for-product?product_id=${encodeURIComponent(productId)}&ts=${ts}`
      : `${WORKER_URL}/colors?ts=${ts}`;
    const r = await fetch(url, { cache: "no-store" });
    const data = await r.json();
    const normalized = {};
    Object.entries(data).forEach(([key, val]) => { normalized[key.toLowerCase().trim()] = val; });
    return normalized;
  }

  async function getMap(productId) {
    const key = productId || "";
    const entry = cache[key];
    if (entry && (Date.now() - entry.fetchedAt) < TTL_MS) return entry.map;
    const map = await fetchMapForProduct(productId);
    cache[key] = { map, fetchedAt: Date.now() };
    return map;
  }

  // ── Refresh all containers after admin save ───────────────────────────────
  async function refreshAllSwatches() {
    Object.keys(cache).forEach(k => delete cache[k]);
    const containers = document.querySelectorAll(".ai-color-swatches[data-colors][data-ai-initialized]");
    await Promise.all([...containers].map(async container => {
      if (typeof container._aiRerender === "function") {
        const pid = container.dataset.productId || "";
        const fresh = await getMap(pid);
        container._aiRerender(fresh);
      }
    }));
  }

  window.addEventListener("message", (e) => {
    if (e.data && e.data.type === "ai-swatches-color-saved") refreshAllSwatches();
  });

  function getShopifyProductId() {
    try { if (window.__shopifyProductId) return String(window.__shopifyProductId); } catch (_) {}
    try { const id = window.ShopifyAnalytics?.meta?.product?.id; if (id) return String(id); } catch (_) {}
    try { const id = window.meta?.product?.id; if (id) return String(id); } catch (_) {}
    try { const id = window.productJSON?.id; if (id) return String(id); } catch (_) {}
    try {
      const jsonScripts = document.querySelectorAll('script[type="application/json"][id*="roduct"]');
      for (const s of jsonScripts) { const data = JSON.parse(s.textContent); const id = data?.id || data?.product?.id; if (id) return String(id); }
    } catch (_) {}
    try {
      const scripts = document.querySelectorAll("script:not([src])");
      const re = /["\s]id["']?\s*:\s*(\d{8,})/;
      for (const s of scripts) { const m = s.textContent.match(re); if (m?.[1]) return m[1]; }
    } catch (_) {}
    try { const el = document.querySelector("[data-product-id]"); if (el?.dataset?.productId) return String(el.dataset.productId); } catch (_) {}
    return "";
  }

  function getShopifyProductType(container) {
    try { if (window.__shopifyProductType) return window.__shopifyProductType; } catch (_) {}
    try { const t = container && container.dataset.productType; if (t) return t; } catch (_) {}
    try { const t = window.ShopifyAnalytics?.meta?.product?.type; if (t) return t; } catch (_) {}
    try { const t = window.meta?.product?.type; if (t) return t; } catch (_) {}
    try { const t = window.productJSON?.product_type; if (t) return t; } catch (_) {}
    try {
      const jsonScripts = document.querySelectorAll('script[type="application/json"][id*="roduct"]');
      for (const s of jsonScripts) { const data = JSON.parse(s.textContent); const t = data?.product_type || data?.product?.product_type; if (t) return t; }
    } catch (_) {}
    try {
      const scripts = document.querySelectorAll("script:not([src])");
      const re = /product_type["']?\s*:\s*["']([^"']+)["']/i;
      for (const s of scripts) { const m = s.textContent.match(re); if (m?.[1]) return m[1]; }
    } catch (_) {}
    return "";
  }

  const JEWELRY_TYPES = ["jewelry","jewellery","jewel","ring","rings","necklace","necklaces","bracelet","bracelets","earring","earrings","pendant","pendants","chain","chains","bangle","bangles","brooch","brooches","anklet","anklets","cuff","cuffs","charm","charms","stud","studs"];
  function isJewelryProductType(t) { if (!t) return false; const l = t.toLowerCase().trim(); return JEWELRY_TYPES.some(x => l.includes(x)); }

  function detectFinish(name, productType, filterLabel) {
    if (filterLabel) { const l = filterLabel.toLowerCase(); if (l.includes("jewelry") || l.includes("jewellery")) return "jewelry"; }
    if (isJewelryProductType(productType)) return "jewelry";

    // For non-jewelry products (clothing, apparel, etc.) always use flat/solid swatches.
    // Special finishes only make sense for jewelry/accessories.
    if (!isJewelryProductType(productType)) return "flat";

    const lower = name.toLowerCase();
    if (["pearl","pearlescent","nacre","lustre","luster","mother of pearl"].some(p => lower.includes(p))) return "pearl";
    if (["gold","silver","bronze","copper","chrome","metallic","rose gold","platinum","titanium","gunmetal","rhodium","vermeil","brass","pewter","gilt"].some(m => lower.includes(m))) return "metallic";
    if (["glossy","gloss","shiny","polished","mirror","lustrous","bright","lacquer","enamel"].some(g => lower.includes(g))) return "glossy";
    if (["iridescent","holographic","rainbow","opal","aurora","galaxy","cosmic","mystic","crystal","ab "].some(i => lower.includes(i))) return "iridescent";
    if (["matte","flat","frosted","satin","brushed"].some(m => lower.includes(m))) return "matte";
    return "flat";
  }

  function hexToRgb(hex) { const n = parseInt(hex.replace("#",""), 16); return { r:(n>>16)&255, g:(n>>8)&255, b:n&255 }; }
  function lighten(hex, amt) { const {r,g,b}=hexToRgb(hex); return `#${Math.min(255,r+amt).toString(16).padStart(2,"0")}${Math.min(255,g+amt).toString(16).padStart(2,"0")}${Math.min(255,b+amt).toString(16).padStart(2,"0")}`; }
  function darken(hex, amt)  { const {r,g,b}=hexToRgb(hex); return `#${Math.max(0,r-amt).toString(16).padStart(2,"0")}${Math.max(0,g-amt).toString(16).padStart(2,"0")}${Math.max(0,b-amt).toString(16).padStart(2,"0")}`; }
  function saturate(hex, factor) {
    const {r,g,b}=hexToRgb(hex); const rn=r/255,gn=g/255,bn=b/255;
    const max=Math.max(rn,gn,bn),min=Math.min(rn,gn,bn); let h,s,l=(max+min)/2;
    if(max===min){h=s=0;}else{ const d=max-min; s=l>0.5?d/(2-max-min):d/(max+min); switch(max){case rn:h=((gn-bn)/d+(gn<bn?6:0))/6;break;case gn:h=((bn-rn)/d+2)/6;break;default:h=((rn-gn)/d+4)/6;} }
    s=Math.min(1,s*factor);
    function hue2rgb(p,q,t){if(t<0)t+=1;if(t>1)t-=1;if(t<1/6)return p+(q-p)*6*t;if(t<1/2)return q;if(t<2/3)return p+(q-p)*(2/3-t)*6;return p;}
    let nr,ng,nb; if(s===0){nr=ng=nb=l;}else{const q=l<0.5?l*(1+s):l+s-l*s,p=2*l-q;nr=hue2rgb(p,q,h+1/3);ng=hue2rgb(p,q,h);nb=hue2rgb(p,q,h-1/3);}
    const toHex=v=>Math.round(v*255).toString(16).padStart(2,"0"); return `#${toHex(nr)}${toHex(ng)}${toHex(nb)}`;
  }
  function luminance(hex) { try { const {r,g,b}=hexToRgb(hex); return 0.2126*(r/255)+0.7152*(g/255)+0.0722*(b/255); } catch{return 0.5;} }

  function getSwatchStyle(hex, finish) {
    const light=lighten(hex,65),midLight=lighten(hex,32),dark=darken(hex,42),vDark=darken(hex,62);
    switch(finish){
      case "jewelry":{
        const richHex=saturate(hex,1.45),vLight=lighten(richHex,80),deepDark=darken(richHex,75),rimLight=lighten(richHex,20),lum=luminance(hex);
        const hi=lum>0.75?`rgba(255,255,255,0.75)`:`rgba(255,255,255,0.98)`;
        return `background:radial-gradient(circle at 32% 28%,${hi} 0%,rgba(255,255,255,0.55) 18%,rgba(255,255,255,0.0) 42%),radial-gradient(circle at 22% 20%,rgba(255,255,255,0.90) 0%,rgba(255,255,255,0.0) 14%),radial-gradient(circle at 68% 72%,${deepDark} 0%,rgba(0,0,0,0.0) 48%),radial-gradient(circle at 50% 80%,${rimLight} 0%,rgba(0,0,0,0.0) 36%),radial-gradient(ellipse at 44% 46%,${vLight} 0%,${richHex} 38%,${darken(richHex,30)} 68%,${deepDark} 100%);box-shadow:none;`;
      }
      case "pearl": return `background:radial-gradient(circle at 34% 27%,rgba(255,255,255,0.92) 0%,rgba(255,255,255,0) 44%),radial-gradient(circle at 62% 68%,rgba(160,200,255,0.22) 0%,transparent 42%),radial-gradient(ellipse at 50% 60%,${vDark} 0%,${hex} 44%,${midLight} 82%,${light} 100%);box-shadow:0 4px 14px rgba(0,0,0,0.40),inset 0 1px 2px rgba(255,255,255,0.55);`;
      case "metallic": return `background:radial-gradient(circle at 35% 27%,rgba(255,255,255,0.88) 0%,rgba(255,255,255,0) 40%),radial-gradient(circle at 68% 72%,rgba(0,0,0,0.30) 0%,transparent 44%),radial-gradient(ellipse at 48% 52%,${light} 0%,${midLight} 22%,${hex} 54%,${dark} 82%,${vDark} 100%);box-shadow:0 4px 14px rgba(0,0,0,0.42),inset 0 1px 2px rgba(255,255,255,0.50);`;
      case "glossy": return `background:radial-gradient(circle at 33% 25%,rgba(255,255,255,0.97) 0%,rgba(255,255,255,0.55) 18%,rgba(255,255,255,0) 40%),radial-gradient(circle at 64% 70%,rgba(0,0,0,0.32) 0%,transparent 44%),radial-gradient(circle at 50% 50%,${light} 0%,${hex} 50%,${vDark} 100%);box-shadow:0 5px 18px rgba(0,0,0,0.50),inset 0 1px 3px rgba(255,255,255,0.65);`;
      case "iridescent": return `background:radial-gradient(circle at 33% 25%,rgba(255,255,255,0.92) 0%,rgba(255,255,255,0.0) 30%),radial-gradient(circle at 74% 20%,rgba(255,60,185,0.85) 0%,rgba(255,60,185,0.0) 36%),radial-gradient(circle at 15% 68%,rgba(25,135,255,0.85) 0%,rgba(25,135,255,0.0) 40%),radial-gradient(circle at 70% 74%,rgba(195,0,255,0.70) 0%,rgba(195,0,255,0.0) 38%),radial-gradient(circle at 50% 50%,rgba(255,125,0,0.38) 0%,rgba(255,125,0,0.0) 50%),radial-gradient(circle at 38% 58%,rgba(0,210,200,0.45) 0%,rgba(0,210,200,0.0) 42%),radial-gradient(ellipse at 50% 57%,#07021a 0%,#130830 36%,#071428 70%,#03010f 100%);box-shadow:0 5px 20px rgba(140,0,255,0.60),0 0 28px rgba(255,0,150,0.30),inset 0 1px 2px rgba(255,255,255,0.42);`;
      case "matte": return `background:radial-gradient(circle at 36% 32%,rgba(255,255,255,0.22) 0%,rgba(255,255,255,0) 52%),radial-gradient(ellipse at 50% 55%,${midLight} 0%,${hex} 55%,${dark} 100%);box-shadow:0 2px 8px rgba(0,0,0,0.22);`;
      default: return `background:${hex};box-shadow:0 1px 4px rgba(0,0,0,0.18);`;
    }
  }

  function resolveHex(map, name) {
    const lower = name.toLowerCase().trim();
    if (map[lower] && map[lower] !== "#cccccc") return map[lower];
    const prefixes = ["gold ","silver ","metallic ","light ","dark ","bright ","deep ","pale ","matte ","glossy ","liquid "];
    const suffixes = [" gold"," silver"," metallic"," multi"," matte"," glossy"," pearl"," chrome"];
    for (const p of prefixes) { if (lower.startsWith(p)) { const base=lower.slice(p.length).trim(); if (map[base]&&map[base]!=="#cccccc") return map[base]; } }
    for (const s of suffixes) { if (lower.endsWith(s)) { const base=lower.slice(0,lower.length-s.length).trim(); if (map[base]&&map[base]!=="#cccccc") return map[base]; } }
    const words = lower.split(" ").filter(w=>w.length>3);
    for (const word of words) { if (map[word]&&map[word]!=="#cccccc") return map[word]; }
    return "#cccccc";
  }

  function splitColor(map, name) {
    const lower = name.toLowerCase().trim();
    const metallics = {"gold":"#FFD700","silver":"#C0C0C0","bronze":"#CD7F32","copper":"#B87333","rose gold":"#B76E79","platinum":"#E5E4E2","chrome":"#DBE4EE","pearl":"#F0EAD6","gunmetal":"#2C3539"};
    for (const [m, mHex] of Object.entries(metallics)) {
      if (lower.endsWith(" "+m)) { let base=lower.slice(0,lower.length-m.length-1).trim().replace(/\bmetallic\b/g,"").trim().replace(/\s+/g," "); const bh=resolveHex(map,base); if(bh!=="#cccccc") return [{hex:bh},{hex:map[m]||mHex}]; }
      if (lower.startsWith(m+" ")) { let base=lower.slice(m.length+1).trim().replace(/^metallic\s+/i,"").trim().replace(/\s+metallic$/i,"").trim(); const bh=resolveHex(map,base); if(bh!=="#cccccc") return [{hex:map[m]||mHex},{hex:bh}]; }
    }
    return [{hex:resolveHex(map,name)}];
  }

  function jewelryDominantHex(map, name) {
    const parts=splitColor(map,name); if(parts.length===1) return parts[0].hex;
    const metallicNames=["gold","silver","bronze","copper","rose gold","platinum","chrome","pearl","gunmetal"];
    const lower=name.toLowerCase();
    for(const m of metallicNames){ if(lower.includes(m)){ const fb={"gold":"#FFD700","silver":"#C0C0C0","bronze":"#CD7F32","copper":"#B87333","rose gold":"#B76E79","platinum":"#E5E4E2","chrome":"#DBE4EE","pearl":"#F0EAD6","gunmetal":"#2C3539"}; return map[m]||fb[m]||parts[0].hex; } }
    return parts[0].hex;
  }

  function getEmbeddedVariants(variantSelects) {
    if (!variantSelects) return null;
    try {
      const sectionId = variantSelects.dataset.section;
      let scriptEl = sectionId ? document.getElementById(`variant-data-${sectionId}`) : null;
      if (!scriptEl) scriptEl = variantSelects.querySelector('script[type="application/json"]');
      if (!scriptEl) return null;
      const parsed = JSON.parse(scriptEl.textContent);
      if (Array.isArray(parsed)) return { variants: parsed, options: null };
      if (parsed.variants) return parsed;
      return null;
    } catch (_) { return null; }
  }

  function getSelectedNonColorOptions(variantSelects, colorOptionIndex0) {
  const selected = {};
  if (!variantSelects) return selected;

  function resolvePosition(input) {
    if (input.dataset.optionPosition) {
      return parseInt(input.dataset.optionPosition, 10) - 1;
    }
    const fieldset = input.closest('[data-index]');
    if (fieldset) {
      const m = fieldset.dataset.index.match(/option(\d+)/);
      if (m) return parseInt(m[1], 10) - 1;
    }
    return null;
  }

  variantSelects.querySelectorAll('input[type="radio"]:checked').forEach(radio => {
    const pos = resolvePosition(radio);
    if (pos !== null && pos !== colorOptionIndex0) selected[pos] = radio.value;
  });

  variantSelects.querySelectorAll('select').forEach(sel => {
    const pos = resolvePosition(sel);
    if (pos !== null && pos !== colorOptionIndex0 && sel.value) selected[pos] = sel.value;
  });

  return selected;
}

  function computeColorAvailability(colorNames, container, variantSelects) {
    const colorOptionIndex0 = parseInt(container.dataset.optionIndex, 10) - 1;
    const data = getEmbeddedVariants(variantSelects);
    if (!data) {
      const raw = container.dataset.variantAvailable;
      if (!raw) return null;
      return raw.split("|||").map(v => v.trim() === "true");
    }
    const { variants } = data;
    const selectedOthers = getSelectedNonColorOptions(variantSelects, colorOptionIndex0);
    const hasOtherSelections = Object.keys(selectedOthers).length > 0;
    return colorNames.map(colorName => {
      return variants.some(variant => {
        const variantOptions = variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);
        if (variantOptions[colorOptionIndex0] !== colorName) return false;
        if (!variant.available) return false;
        if (hasOtherSelections) {
          for (const [idxStr, val] of Object.entries(selectedOthers)) {
            if (variantOptions[parseInt(idxStr,10)] !== val) return false;
          }
        }
        return true;
      });
    });
  }

  // ── NEW: recompute availability for every OTHER option (e.g. Size) once a
  // color swatch is clicked, and write it back onto each radio/option's
  // data-available attribute so the theme's existing CSS strike-through
  // picks it up automatically. ──────────────────────────────────────────────
  function updateSiblingOptionAvailability(variantSelects, colorOptionIndex0, selectedColorName) {
    if (!variantSelects) return;
    const data = getEmbeddedVariants(variantSelects);
    if (!data) return;
    const { variants } = data;

    variantSelects.querySelectorAll('fieldset[data-index]').forEach(fieldset => {
      const m = fieldset.dataset.index.match(/option(\d+)/);
      if (!m) return;
      const idx0 = parseInt(m[1], 10) - 1;
      if (idx0 === colorOptionIndex0) return; // skip the color fieldset itself

      // Radio-button style options (e.g. Size as buttons)
      fieldset.querySelectorAll('input[type="radio"]').forEach(input => {
        const value = input.value;
        const matches = variants.some(v => {
          const opts = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
          return opts[colorOptionIndex0] === selectedColorName && opts[idx0] === value && v.available;
        });
        input.dataset.available = matches ? "true" : "false";
        input.setAttribute('data-available', matches ? "true" : "false");
      });

      // Dropdown-style options (e.g. Size as a <select>)
      fieldset.querySelectorAll('select option').forEach(opt => {
        const value = opt.value;
        if (!value) return;
        const matches = variants.some(v => {
          const opts = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
          return opts[colorOptionIndex0] === selectedColorName && opts[idx0] === value && v.available;
        });
        opt.dataset.available = matches ? "true" : "false";
        opt.setAttribute('data-available', matches ? "true" : "false");
      });
    });
  }

  function createSwatch(name, map, isSelected, isAvailable, onClick, productType, filterLabel) {
    const parts = splitColor(map, name);
    const finish = detectFinish(name, productType, filterLabel);
    const primaryHex = finish === "jewelry" ? jewelryDominantHex(map, name) : parts[0].hex;
    const lum = luminance(primaryHex);
    const ringColor = lum > 0.6 ? "#333" : primaryHex;
    const btn = document.createElement("button");
    btn.type = "button";
    btn.title = isAvailable ? name : `${name} - Sold out`;
    btn.setAttribute("aria-label", isAvailable ? name : `${name} - Sold out`);
    btn.setAttribute("data-color-name", name);
    btn.setAttribute("data-selected", isSelected ? "true" : "false");
    btn.setAttribute("data-available", isAvailable ? "true" : "false");
    let bgStyle;
    if (parts.length === 2 && finish !== "jewelry") {
      bgStyle = `background:linear-gradient(135deg,${parts[0].hex} 50%,${parts[1].hex} 50%);`;
    } else {
      bgStyle = getSwatchStyle(primaryHex, finish).replace(/\n\s+/g," ").trim();
    }
    btn.style.cssText = `width:32px;height:32px;border-radius:50%;${bgStyle}border:2.5px solid ${isSelected?ringColor:"transparent"};outline:${isSelected?`2px solid ${ringColor}`:"none"};outline-offset:2px;cursor:${isAvailable?"pointer":"not-allowed"};transition:transform 0.15s ease,outline 0.15s ease,opacity 0.15s ease;transform:${isSelected?"scale(1.18)":"scale(1)"};padding:0;flex-shrink:0;overflow:hidden;position:relative;`;
    if (!isAvailable) {
      const line = document.createElement("span");
      line.setAttribute("aria-hidden","true");
      line.style.cssText = `position:absolute;inset:0;border-radius:50%;background:linear-gradient(135deg,transparent calc(50% - 1.5px),rgba(180,0,0,0.85) calc(50% - 1.5px),rgba(180,0,0,0.85) calc(50% + 1.5px),transparent calc(50% + 1.5px));pointer-events:none;`;
      btn.appendChild(line);
    }
    btn.addEventListener("mouseenter", () => { if (btn.getAttribute("data-selected") !== "true") btn.style.transform = "scale(1.1)"; });
    btn.addEventListener("mouseleave", () => { if (btn.getAttribute("data-selected") !== "true") btn.style.transform = "scale(1)"; });
    btn.addEventListener("click", () => onClick(name, isAvailable));
    return btn;
  }

  function renderSwatches(container, colorNames, availabilityArr, map, selected, onSelect, productType, filterLabel) {
    container.innerHTML = "";
    const isProductCard = container.closest(".product-card") !== null;
    const MAX_VISIBLE = 8;
    const limited = isProductCard && colorNames.length > MAX_VISIBLE;
    const visibleNames = limited ? colorNames.slice(0, MAX_VISIBLE) : colorNames;
    const remaining = colorNames.length - MAX_VISIBLE;
    visibleNames.forEach((name, i) => {
      const isAvailable = availabilityArr ? availabilityArr[i] !== false : true;
      const swatch = createSwatch(name, map, name === selected, isAvailable, onSelect, productType, filterLabel);
      container.appendChild(swatch);
    });
    if (limited) {
      const more = document.createElement("span");
      more.style.cssText = `display:inline-flex;align-items:center;justify-content:center;width:32px;height:32px;border-radius:50%;background:#f0f0f0;color:#333;font-size:10px;font-weight:600;flex-shrink:0;cursor:default;`;
      more.textContent = `+${remaining}`;
      more.title = `${remaining} more colors available`;
      container.appendChild(more);
    }
  }

  function swapCardImage(card, src375, src770) {
    const img = card.querySelector(".product-primary-image");
    if (!img) return;
    img.style.transition = "opacity 0.18s ease"; img.style.opacity = "0";
    let done = false;
    const doSwap = () => {
      if ("lazySizes" in window || img.classList.contains("lazyload") || img.classList.contains("lazyloaded")) {
        img.dataset.src = src375; img.dataset.srcset = src375+" 375w,"+src770+" 770w";
        img.classList.remove("lazyloaded"); img.classList.add("lazyload");
        if (window.lazySizes) window.lazySizes.loader.unveil(img);
      } else { img.src = src375; img.srcset = src375+" 375w,"+src770+" 770w"; }
      img.style.opacity = "1";
    };
    img.addEventListener("transitionend", function handler() { if(done)return;done=true;img.removeEventListener("transitionend",handler);doSwap(); });
    setTimeout(() => { if (!done){done=true;doSwap();} }, 220);
  }

  function syncVariant(container, colorName) {
    if (container.classList.contains("ai-facet-swatches")) {
      const hiddenOriginal = container.nextElementSibling;
      if (hiddenOriginal) {
        const checkboxes = hiddenOriginal.querySelectorAll('input[type="checkbox"]');
        for (const cb of checkboxes) { if (cb.value === colorName) { cb.checked = !cb.checked; break; } }
        const form = hiddenOriginal.closest("form");
        if (form) {
          const params = new URLSearchParams();
          form.querySelectorAll('input[type="checkbox"]:checked').forEach(c => params.append(c.name, c.value));
          const sortEl = form.querySelector('select[name="sort_by"]');
          if (sortEl) params.set("sort_by", sortEl.value);
          window.location.href = window.location.pathname + "?" + params.toString();
        }
      }
      return;
    }
    const card = container.closest(".product-card");
    if (card) {
      const names   = container.dataset.colors.split("|||").map(s => s.trim());
      const urlsRaw = container.dataset.variantUrls   || "";
      const imgsRaw = container.dataset.variantImages || "";
      const idx     = names.indexOf(colorName);
      if (imgsRaw && idx !== -1) {
        const entry = imgsRaw.split("|||")[idx] || "";
        const parts = entry.split(":::");
        if (parts[0]) swapCardImage(card, parts[0], parts[1] || parts[0]);
      }
      if (urlsRaw && idx !== -1) {
        const variantUrl = urlsRaw.split("|||")[idx];
        if (variantUrl) {
          card.querySelectorAll("a.product-card--featured-image-link, a.product-card-title")
              .forEach(link => link.setAttribute("href", variantUrl));
        }
      }
      return;
    }
    const labelId = container.dataset.labelId;
    const labelEl = document.getElementById(labelId);
    if (labelEl) labelEl.textContent = colorName;
    const hiddenOriginal = container.parentElement?.querySelector(".ai-swatches-hidden-original");
    if (hiddenOriginal) {
      const radios = hiddenOriginal.querySelectorAll('input[type="radio"]');
      let found = false;
      for (const radio of radios) {
        if (radio.value === colorName) {
          radios.forEach(r => r.checked = false);
          radio.checked = true; radio.click();
          radio.dispatchEvent(new Event("change", { bubbles: true }));
          found = true; break;
        }
      }
      if (!found) console.warn("[AI Swatches] Radio not found:", colorName);
    } else {
      const form = document.getElementById(container.dataset.formId);
      if (form) {
        for (const radio of form.querySelectorAll('input[type="radio"]')) {
          if (radio.value === colorName) {
            radio.checked = true; radio.click();
            radio.dispatchEvent(new Event("change", { bubbles: true }));
            break;
          }
        }
      }
    }
  }

  async function initContainer(container) {
    if (container.dataset.aiInitialized) return;
    container.dataset.aiInitialized = "true";

    const colorNames = container.dataset.colors.split("|||").map(c => c.trim()).filter(Boolean);
    if (!colorNames.length) return;

    const productType = getShopifyProductType(container);
    const filterLabel = container.dataset.filterLabel || "";

    // KEY FIX: use data-product-id on the container (set by the Liquid snippet)
    // so collection/listing pages get per-product overrides, not just the global map.
    const productId = container.dataset.productId || getShopifyProductId() || "";

    if (!document.getElementById("ai-swatch-styles")) {
      const style = document.createElement("style");
      style.id = "ai-swatch-styles";
      style.textContent = `@keyframes swatch-shimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}.ai-color-swatches{display:flex;gap:15px;flex-wrap:wrap;align-items:center;margin:10px 0 16px;}.ai-color-swatches button:focus-visible{outline:2px solid #333;outline-offset:3px;}.ai-swatch-skeleton{width:32px;height:32px;border-radius:50%;background:linear-gradient(90deg,#eee 25%,#f5f5f5 50%,#eee 75%);background-size:200% 100%;animation:swatch-shimmer 1.2s infinite;display:inline-block;flex-shrink:0;}.ai-swatches-hidden-original{position:absolute;width:1px;height:1px;overflow:hidden;opacity:0;pointer-events:none;clip:rect(0,0,0,0);}`;
      document.head.appendChild(style);
    }

    container.innerHTML = colorNames.map(() => `<span class="ai-swatch-skeleton"></span>`).join("");

    const map = await getMap(productId);
    let selected = colorNames[0];
    const variantSelects = container.closest("variant-selects");

    function rerender(freshMap) {
      const activeMap = freshMap || map;
      const availabilityArr = computeColorAvailability(colorNames, container, variantSelects);
      renderSwatches(container, colorNames, availabilityArr, activeMap, selected, onSelect, productType, filterLabel);
    }

    container._aiRerender = rerender;

    function onSelect(name) {
      selected = name;
      rerender();
      syncVariant(container, name);

      // NEW: after switching color, recompute Size (and any other option's)
      // availability so its strike-through / disabled state stays in sync.
      const colorOptionIndex0 = parseInt(container.dataset.optionIndex, 10) - 1;
      updateSiblingOptionAvailability(variantSelects, colorOptionIndex0, name);
    }

    rerender();

    // Also sync sibling-option availability once on initial load, using the
    // initially selected color, in case the page was rendered before this
    // script ran.
    if (variantSelects) {
      const colorOptionIndex0Init = parseInt(container.dataset.optionIndex, 10) - 1;
      updateSiblingOptionAvailability(variantSelects, colorOptionIndex0Init, selected);
    }

    if (variantSelects) {
      const colorOptionIndex1Based = container.dataset.optionIndex;
      variantSelects.addEventListener("change", (e) => {
        const target = e.target;
        if (target.closest(".ai-swatches-hidden-original")) return;
        const pos = target.dataset?.optionPosition || target.closest("[data-option-position]")?.dataset?.optionPosition;
        if (pos && pos === colorOptionIndex1Based) return;
        rerender();
      });
      variantSelects.addEventListener("click", (e) => {
        const target = e.target.closest('[data-option-position],.product-option button,.variant-button');
        if (!target) return;
        if (target.closest(".ai-color-swatches") || target.closest(".ai-swatches-hidden-original")) return;
        setTimeout(rerender, 50);
      });
    }
  }

  async function init() {
    const containers = document.querySelectorAll(".ai-color-swatches[data-colors]");
    if (!containers.length) return;
    containers.forEach(container => {
      container.removeAttribute("data-ai-initialized");
      container.innerHTML = "";
    });
    await Promise.all([...containers].map(initContainer));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  const facetObserver = new MutationObserver((mutations) => {
    // Re-init facet swatches (existing behaviour)
    document.querySelectorAll('.ai-facet-swatches[data-colors]').forEach(container => {
      if (!container.querySelector('button') && container.dataset.colors) {
        initContainer(container);
      }
    });

    // Re-init product card swatches injected by facet/AJAX re-render
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return; // element nodes only
        // Check if the added node itself is a swatch container
        if (node.matches && node.matches('.ai-color-swatches[data-colors]')) {
          node.removeAttribute('data-ai-initialized');
          initContainer(node);
        }
        // Check descendants of the added node
        if (node.querySelectorAll) {
          node.querySelectorAll('.ai-color-swatches[data-colors]').forEach(container => {
            container.removeAttribute('data-ai-initialized');
            initContainer(container);
          });
        }
      });
    });
  });
  facetObserver.observe(document.body, { childList: true, subtree: true });

  window.AIColorSwatches = { init: initContainer, reload: init, refresh: refreshAllSwatches };
})();